import { rootContract } from './root.contract';
import { projectsContract } from './projects.contract';
import { organizationsContract } from './organizations.contract';
import { issuesContract } from './issues.contract';
import { translationsContract } from './translations.contract';

// Individual re-exports (for route files importing specific contracts)
export { rootContract } from './root.contract';
export { projectsContract } from './projects.contract';
export { organizationsContract } from './organizations.contract';
export { issuesContract } from './issues.contract';
export { translationsContract } from './translations.contract';

// Aggregated export for service client creation
export const storageAccessContracts = {
	rootContract,
	projectsContract,
	organizationsContract,
	issuesContract,
	translationsContract,
};
